import { Component, inject } from '@angular/core';
import { NavigationPipe } from '../../pipes/navigation/navigation.pipe';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Path } from '../../constants/paths.constant';
import { LogoComponent } from '../logo/logo.component';
import {
  FacebookIconComponent,
  InstagramIconComponent,
  LinkedinIconComponent,
  TiktokIconComponent,
  XIconComponent,
  YoutubeIconComponent,
} from '@mars/ui-components';
import { BrandingService } from '../../branding/branding.service';

@Component({
  selector: 'mars-footer',
  imports: [
    NavigationPipe,
    RouterLink,
    RouterLinkActive,
    TranslocoModule,
    LogoComponent,
    FacebookIconComponent,
    InstagramIconComponent,
    LinkedinIconComponent,
    TiktokIconComponent,
    XIconComponent,
    YoutubeIconComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected readonly Path = Path;
  protected readonly branding = inject(BrandingService);

  /** A replica's real profile URL opens in a new tab; anything else (e.g. `#`) stays in it. */
  protected isExternal(url: string) {
    return /^https?:\/\//i.test(url);
  }
}
